import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import "../Curriculum.css";
import GeneralUtils from "../../../../../utils/GeneralUtils";
import {toast} from "react-toastify";
import {Divider} from "primereact/divider";
import {Editor} from "primereact/editor";
import {RadioButton} from "primereact/radiobutton";
import {Card} from "primereact/card";
import OptionForm from "./QptionForm";
import {Dropdown} from "primereact/dropdown";
import {LectureService} from "../../../../../service/LectureService";

const defaultQuestion = {
    question: '',
    questionType: 'MultipleChoice',
    objectIndex: 1,
    optionList: [],
    relatedLectureIds: []
}
const DEFAULT_OPTION_COUNT = 4;
const QUESTION_TYPES = [
    { label: "Çoktan Seçmeli", value: "MultipleChoice" },
    { label: "Doğru-Yanlış", value: "TrueFalse" },
    { label: "Açık Uçlu", value: "OpenEnded" }
];
const QuestionForm = (props) => {
    const {chapter, index, cancel, save} = props;
    const [data, setData] = useState(!GeneralUtils.isNullOrEmpty(props.data) ? props.data : defaultQuestion);
    const [lecture, setLecture] = useState([]);
    // Mevcut veride isCorrect olan varsa onu başlangıç olarak seç
    const [correctIndex, setCorrectIndex] = useState(() => {
        const list = props.data?.optionList || [];
        const i = list.findIndex((o) => o?.isCorrect);
        return i >= 0 ? i : null;
    });
    const lectureService = new LectureService();

    useEffect(() => {
        if (chapter) {
            lectureService.findByChapterId(chapter.id)
                .then(response => {
                    setLecture(response);
                })
                .catch(err => console.error("Lecture listesi alınamadı", err));
        }
    }, [chapter]);

    const handleSave = () => {
        if (GeneralUtils.isNullOrEmpty(data.question)) {
            return toast.warn('Lütfen tüm alanlarını doldurun.');
        }
        if (data.questionType === "MultipleChoice" && data.optionList?.length < DEFAULT_OPTION_COUNT) {
            return toast.warn("Lütfen tüm seçenekleri girin.");
        }
        if (data.questionType !== "OpenEnded" && correctIndex == null) {
            return toast.warn("Lütfen doğru cevabı seçin.");
        }
        if (data.questionType === "TrueFalse") {
            data.optionList = [
                { answer: "Doğru", isCorrect: correctIndex === 0, objectIndex: 1 },
                { answer: "Yanlış", isCorrect: correctIndex === 1, objectIndex: 2 }
            ];
        }


        setData(data);
        save(data);
    }

    const handleChangeQuestion = (e) => {
        setData((prev) => ({ ...prev, question: e.htmlValue }));
    };

    const handleChangeOption = (option, index) => {
        setData(prevData => {
            const optionList = [...(prevData.optionList || [])];
            option.objectIndex = index + 1;
            optionList[index] = option ?? {};
            return { ...prevData, optionList };
        });
    };

    const handleSelectCorrect = (idx) => {
        setCorrectIndex(idx);
        // tüm şıkları güncelle: yalnızca seçilen doğru
        setData((prev) => ({
            ...prev,
            optionList: (prev.optionList || []).map((opt, i) => ({
                ...opt,
                isCorrect: i === idx,
            })),
        }));
    };


    const handleChangeRelatedLecture = (e) => {
        const { value } = e.target;
        setData((prev) => ({
            ...prev,
            relatedLectureIds: value ? [value] : []
        }));
    };


    const header = (
        <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
            </span>
    );

    return (
        <Card className="question-editor noshadow">
        <div className="flex flex-column mb-2">
            <Divider align="left"><b> <i className="pi pi-question mr-2"></i>Soru {index + 1}</b></Divider>
            <Editor id="body" value={data.question} onTextChange={handleChangeQuestion}
                    headerTemplate={header}
                    style={{height: '120px'}}/>


            {data.questionType !== "OpenEnded" && <Divider align="left"><b> <i className="pi pi-book mr-2"></i>Seçenekler</b></Divider>}
            {data.questionType === "MultipleChoice" && Array.from({length: Math.max(5, data?.optionList?.length || 0)})
                .map((_, index) => (
                    <OptionForm
                        key={`option-${index}`}
                        index={index}
                        correctIndex={correctIndex}
                        onSelectCorrect={handleSelectCorrect}
                        data={data?.optionList?.[index]}
                        onChange={handleChangeOption}/>
                ))}

            {data.questionType === "TrueFalse" && ["Doğru", "Yanlış"].map((label, index) => (
                <div key={index} className="flex flex-row gap-2 align-items-center">
                    <RadioButton
                        inputId={`option-${index}`}
                        name="correctOption"
                        value={index}
                        checked={correctIndex === index} onChange={(e) => handleSelectCorrect(e.value)}
                    />
                    <label htmlFor={`option-${index}`} className="ml-2">{label}</label>
                </div>
            ))}


            <Divider align="left"><b> <i className="pi pi-book mr-2"></i>İlgili Ders</b></Divider>
            <Dropdown name="relatedLecture" value={data?.relatedLectureIds?.[0] ? Number(data.relatedLectureIds[0]) : null} onChange={handleChangeRelatedLecture}
                      id="relatedLecture"
                      options={lecture} optionLabel="title" optionValue="id" placeholder="---Ders Seçin---"
                      emptyMessage="Kayıt Bulunamadı"
                      className="w-full md:w-14rem p-inputtext-sm"/>


            <div className="flex justify-content-end gap-2">
                <Button label="İptal" onClick={cancel} outlined size="small"/>
                <Button label="Kaydet" onClick={handleSave} raised size="small"/>
            </div>
        </div>
        </Card>
    )
};




export default QuestionForm;
